export default __webpack_public_path__ + "static/media/Path 49373.61db08b4.svg";